import React from 'react';
import clsx from 'clsx';
import MarkdownCell from '@/components/table/MarkdownCell';

const FormObjectMarkdownCell = ({ field, item }) => (
  <MarkdownCell
    className={clsx(`aridhia-form-object-markdown-cell-${field.type}`, 'td-description')}
    collapsing
    value={item[field.name]}
  />
);

export default FormObjectMarkdownCell;
